import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { MbPopoverTrigger, MbFormFieldModule, MbPopoverModule } from '@am/moebius';
import { AnalyticsService } from '@core/services';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertContentComponent } from '@commons/alert-content/alert-content.component';

@Component({
    selector: 'payment-method-selector',
    templateUrl: './payment-method-selector.component.html',
    styleUrls: ['./payment-method-selector.component.scss'],
    standalone: true,
    imports: [
        AlertContentComponent,
        MbFormFieldModule,
        MbPopoverModule,
        FormsModule,
        NgIf,
    ],
})
export class PaymentMethodSelectorComponent implements OnInit, OnChanges {
  @ViewChild(MbPopoverTrigger, { static: true }) popover: MbPopoverTrigger;

  @Input()
  selectedPaymentMethod: any;
  @Input()
  showAlert: any;
  @Output()
  paymentMethodChange: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  countryId: any;
  public isArgentina: boolean;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.isArgentina = ['1123215', 'NEW8'].includes(this.countryId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showAlert && !changes.showAlert.isFirstChange()) {
      this.showPaymentsMethodsAlert(changes.showAlert.currentValue.value);
    }
  }

  private show() {
    this.popover.show();
  }

  public hide() {
    this.popover.hide();
  }

  private showPaymentsMethodsAlert(status: boolean) {
    if (status) {
      this.show();
    }
  }

  public applyChange() {
    this.paymentMethodChange.emit(this.selectedPaymentMethod);
    this.trackRoomOptionsDropdown(this.selectedPaymentMethod);
  }

  private trackRoomOptionsDropdown(paymentMethod) {
    this.analyticsService.trackEvent({
      section: 'Detail',
      action: 'Payment Method Dropdown Selection',
      label: paymentMethod.toLowerCase(),
    });
  }
}
